<template>
  <div class="invoice-apply-list">
    <div class="search-wrp">
      <div class="search-ipt">
        <input type="text" v-model="searchParams.purchaserName" placeholder="客户名称" />
        <i @click="onSearch" class="huixiaopiaofont">&#xe6f5;</i>
      </div>
      <van-row class="condition-wrap">
        <van-col span="12" class="date">{{searchParams.date}}</van-col>
        <van-col span="12" class="status">
          <van-dropdown-menu>
            <van-dropdown-item
              v-model="searchParams.invoiceStatus"
              :options="statusOptions"
              @change="changeStatus"
            />
          </van-dropdown-menu>
        </van-col>
      </van-row>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <InvoiceCard type="apply" v-for="(invoice, index) in invoiceList" :key="index" :invoice="invoice" :btnList="invoice.status >= 2 ? ['delete'] : invoice.settlementSource !== 2 ? ['edit', 'delete'] : ['delete']" />
      </van-list>
    </van-pull-refresh>
    <div class="float-btn" @click="showChioce">新建申请</div>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Field,
  Row,
  Col,
  DropdownMenu,
  DropdownItem,
  Button,
  Notify,
  List,
  PullRefresh
} from 'vant'

import {
  renderTextWithConfig
} from '@utils/basicUtil'

import {
  INVOICE_STATUS
} from '@assets/config'

import InvoiceCard from '@components/InvoiceCard'
import { invoiceRequest } from '@services'

export default {
  data: () => ({
    searchParams: {
      size: 25,
      current: 1,
      purchaserName: '',
      date: '',
      invoiceStatus: undefined
    },
    statusOptions: [
      { text: '所有', value: undefined },
      { text: '未开具', value: 0 },
      { text: '开票异常', value: 1 }
    ],
    invoiceList: [],
    refreshing: false,
    loading: false,
    finished: false
  }),
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      this.getApplyList()
    },
    showChioce () {
      this.$store.commit('invoice/changeShowChoice', true)
    },
    gotoAddInvoice () {
      this.$router.push('/invoice/add-apply')
    },
    renderStatus (text) {
      return renderTextWithConfig(text, INVOICE_STATUS)
    },
    changePurchaserName (e) {
      this.searchParams.purchaserName = e
    },
    changeStatus (value) {
      this.searchParams.invoiceStatus = value
      this.onRefresh()
    },
    async getApplyList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const data = await invoiceRequest.apply.getApplyList(this.searchParams)
      if (data.success) {
        if (data.result.records) {
          this.invoiceList = [...this.invoiceList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }

      this.loading = false
    },
    onRefresh () {
      this.finished = false
      this.searchParams.current = 1
      this.invoiceList = []
      this.getApplyList()
    },
    onLoad () {
      this.searchParams.current++
      this.getApplyList()
    },
    onSearch () {
      this.onRefresh()
    }
  },
  components: {
    InvoiceCard,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Field.name]: Field,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
